const LOCAL_STORAGE_KEY = 'continueMedia'
const MAX_ITEMS = 3

/**
 * Fetches and updates the continue media list in local storage.
 * Currently we'll only store the last 3 unique items.
 *
 * @param {Object} newItem - The new media item to add.
 * @param {string} variant - ebook or audiobook.
 */

export const updateContinueMedia = (newItem, variant) => {
  if (!newItem || !newItem.mediaId || !newItem[variant].sku) {
    return
  }

  try {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY)
    const list = stored ? JSON.parse(stored) : []

    const alreadyExists = list.some(
      (item) =>
        item.mediaId === newItem.mediaId &&
        (item[variant] && item[variant].sku) === (newItem[variant] && newItem[variant].sku),
    )

    // If the item already exists, we don't need to update the list
    if (alreadyExists) return

    const itemWithVariant = Object.assign({ continueVariant: variant }, newItem)

    // Add the new item to the beginning of the list and remove the oldest one if necessary
    const updatedList = [itemWithVariant, ...list].slice(0, MAX_ITEMS)

    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updatedList))
  } catch (error) {
    console.error('Failed to update continue media list:', error)
  }
}
